import React from 'react'
import PropTypes from 'prop-types'
import { minorScale, majorScale, Pane, Text, defaultTheme } from 'evergreen-ui'

export default class Step extends React.PureComponent {
  static propTypes = {
    /**
     * The name of the step. Keep this short.
     */
    children: PropTypes.node,

    /**
     * The number to display before the text.
     */
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * Set this to true when it's the current step.
     * This will highlight the item.
     */
    isActive: PropTypes.bool,

    /**
     * Set this when the item is clickable.
     */
    isAccessible: PropTypes.bool
  }

  render() {
    const { step, isActive, isAccessible, children, onClick } = this.props

    let cursor = 'pointer'
    let textColor = defaultTheme.scales.neutral.N9
    let badgeBackgroundColor = defaultTheme.scales.neutral.N7
    let badgeTextColor = 'white'
    let badgeShadow

    if (isActive) {
      cursor = 'default'
      textColor = defaultTheme.palette.blue.base
      badgeBackgroundColor = defaultTheme.palette.blue.base
    }

    if (!isAccessible) {
      cursor = 'not-allowed'
      textColor = defaultTheme.scales.neutral.N7
      badgeTextColor = defaultTheme.scales.neutral.N6
      badgeBackgroundColor = null
      badgeShadow = `inset 0 0 0 1px ${defaultTheme.scales.neutral.N5}`
    }

    return (
      <Pane
        marginX={minorScale(3)}
        display="flex"
        alignItems="center"
        cursor={cursor}
        onClick={isAccessible ? onClick : undefined}
      >
        <Pane
          background={badgeBackgroundColor}
          boxShadow={badgeShadow}
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={majorScale(2)}
          width={majorScale(2)}
          borderRadius={majorScale(2)}
          marginRight={majorScale(1)}
        >
          <Text color={badgeTextColor} size={300} fontWeight={600}>
            {step}
          </Text>
        </Pane>

        <Text color={textColor} fontWeight={500} size={400}>
          {children}
        </Text>
      </Pane>
    )
  }
}
